<div class="sol-empty-state" [attr.data-testid]="id$()">
  @if (hasIcon$()) {
    <div class="sol-empty-state-icon">
      <sol-icon [name]="icon$()" size="64" />
    </div>
  }

  <div class="sol-empty-state-title" data-testid="sol-empty-state-title">
    {{ title$() | translate }}
  </div>

  @if (hasText$()) {
    <div class="sol-empty-state-text">
      <sol-text-box [box]="text$()!" />
    </div>
  }

  @if (hasCustomContent$()) {
    <div class="sol-empty-state-content">
      <ng-content />
    </div>
  }

  @if (actionButton$()) {
    <div class="sol-empty-state-action" data-testid="sol-empty-state-action">
      <sol-button [button]="actionButton$()!" (click)="onAction()" />
    </div>
  }
</div>
